import { Injectable, signal } from '@angular/core';
import { Content, NodeModel, BatchContent, BatchResult } from '@xanadu/model';

@Injectable({
    providedIn: 'root'
})
export class BatchSignal {
    on = signal<NodeModel | undefined>(undefined);
    off = signal<NodeModel | undefined>(undefined);

    prototype = signal<string | undefined>(undefined);
    content = signal<BatchContent | undefined>(undefined);

    save = signal<Content | undefined>(undefined);
    done = signal<BatchResult | undefined>(undefined);
    update = signal<any>(undefined);

    toggle(model: NodeModel, on: boolean): void {
        if (on) {
            this.on.set(model);
            this.off.set(undefined);
        } else {
            this.off.set(model);
            this.on.set(undefined);
        }
    }

    clear(): void {
        this.prototype.set(undefined);
        this.content.set(undefined);
    }

    reset(): void {
        this.save.set(undefined);
        this.done.set(undefined);
        this.update.set(undefined);
    }
}
